import moment, { Moment } from 'moment';

const BY_COMMA = /\s*,\s*/;

export function mapCheckbox(checkboxes: boolean[], array: any[], property?: string): string[] {
  const selected: Array<string> = [];
  checkboxes = checkboxes || [];

  checkboxes.forEach((value, index) => value && selected.push(property ? array[index][property] : array[index]));

  return selected.length ? selected : null;
}

export function clearEmptyProperties(object: object): object {
  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      const value = object[key];
      if (value === null || value === undefined || value === '' || value.length === 0) {
        delete object[key];
      }
    }
  }
  return object;
}

export function startOfDay(value?: Moment, format?: string): string {
  if (!value) {
    return undefined;
  }
  const valueAsMoment = moment(value).startOf('day');
  return format ? valueAsMoment.format(format) : valueAsMoment.toISOString();
}

export function endOfDay(value?: Moment, format?: string): string {
  if (!value) {
    return undefined;
  }
  const valueAsMoment = moment(value).endOf('day');
  return format ? valueAsMoment.format(format) : valueAsMoment.toISOString();
}

export function mapIds(values?: Array<{ id?: string }>): string[] {
  if (values && values.length) {
    return values.map((value) => value && value.id);
  }

  return undefined;
}

export function mapStringToArrayOfIds(values?: string[]): Record<any, string>[] {
  if (values && values.length) {
    return values.map((value) => ({ id: value }));
  }

  return [];
}

export function mapId(value?: { id?: string }): string {
  if (value && value.id) {
    return value.id;
  }

  return undefined;
}

export function splitStringByComma(ids: string | string[]): string[] {
  return String(ids || '').split(BY_COMMA).map((item) => item.trim()).filter(Boolean);
}

export function parseDate(date: string): Moment {
  if (date) {
    const parsed = moment(date);
    if (parsed.isValid()) {
      return parsed;
    }
  }
  return null;
}

export function parseIdsToBooleanArray(values: any[], ids: string | string[], property: string): boolean[] {
  const selectedIds = splitStringByComma(ids);
  return values.map((item) => selectedIds.includes(item[property]));
}


export function parseJson(value: string): any {
  try {
    return JSON.parse(value);
  } catch (ignored) {
    return null;
  }
}

export function intervalBetweenPeriodDates(initialDate, finalDate: string): number {
  try {
    return Math.floor((Date.parse(finalDate) - Date.parse(initialDate)) / 86400000);
  } catch (ignored) {
    return null;
  }
}

export function parseBoolean(value: string): boolean {
  return Boolean(String(value) === 'true');
}
